module.exports = __webpack_public_path__ + "img/togglemenu.acf029f5.svg";